interface SkillChipProps {
  label: string;
}

/** Mono token tag — reads like a dependency in a manifest. */
const SkillChip = ({ label }: SkillChipProps): JSX.Element => (
  <span className="rounded border border-[color:var(--hairline)] px-2.5 py-1 font-mono text-xs font-medium text-[color:var(--fg-muted)] transition-colors hover:border-primary-dark hover:text-primary-ink dark:hover:border-primary dark:hover:text-primary">
    {label}
  </span>
);

export default SkillChip;
